var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('q-btn',{staticClass:"q-mr-xs",attrs:{"aria-label":"Zurück","type":"a","to":_vm.to,"icon":"fal fa-long-arrow-left","color":"primary","flat":"","round":""},on:{"click":function($event){return _vm.$emit('click', $event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }